import { useMemo } from 'react'

import { Divider } from '@mui/material'

import { MAX_LOADS_FOR_ORDER } from '@/constants'

import * as OrderTexts from '../../../../../../../intl'
import { form } from '../../../../formState'
import { OrderFormValues } from '../../../../typings'
import { Props } from '../../typings'
import { LoadOption } from './types'
import validateLoadField from './validation/validateLoadField'

import { LoadListField } from './components/LoadListField'

export function Loads(props: Props) {
  const { loads, type } = props

  const isService = type === 's'

  const options: LoadOption[] = useMemo(
    () =>
      loads.map(load => ({
        label: load,
        value: load,
      })),
    [loads],
  )

  form.useAddFieldValidation('order.loads', (field, _formApi) => {
    if (field.value) {
      const loadFieldsErrors: Record<string, { name?: string; value?: string }> = validateLoadField(
        field.value,
      )

      if (Object.keys(loadFieldsErrors).length > 0) {
        return JSON.stringify(loadFieldsErrors)
      }
    }
  })

  return (
    <>
      {/* Hide loads field for service orders */}
      {!isService && (
        <>
          <form.Fieldset data-testid="loads-list">
            <LoadListField<'order.loads', OrderFormValues>
              name="order.loads"
              loadListProps={{
                testId: 'loads',
                label: OrderTexts.getFieldLabelLoadsText(),
                options,
                maxSelectionsCount: MAX_LOADS_FOR_ORDER,
              }}
            />
          </form.Fieldset>
          <Divider />
        </>
      )}
    </>
  )
}
